import { Skeleton } from "components/ui/skeleton/Skeleton"
import { H2 } from "components/ui/typography/titles/Titles"
import { AddModelObject } from "./layout/AddModelObject/AddModelObject"
import { Categories } from "./layout/Categories/Categories"
import { useObjectsCategories } from "hooks/api/objectsCategories/objectsCategories.hook"
import { useCurrentUserStore } from "store/user.store"
import style from "./ObjectsCategories.module.scss"

const { objectsCategories, topBlock, skeletonContainer, title } = style

export const ObjectsCategories = () => {
	const {
		data: objectCategoriesData,
		isPending: objectCategoriesPending,
		error: objectCategoriesError,
		refetch: objectCategoriesRefetch,
	} = useObjectsCategories()
	const { currentUser } = useCurrentUserStore()

	if (objectCategoriesPending) {
		return (
			<div className={skeletonContainer} data-testid="skeleton">
				<Skeleton rows={12} />
			</div>
		)
	}

	return (
		<div className={objectsCategories}>
			<div className={topBlock}>
				<H2 className={title}>Categories of objects</H2>
				{currentUser?.role === "Super Admin" ? (
					<AddModelObject objectCategoriesRefetch={objectCategoriesRefetch} />
				) : null}
			</div>
			<div>
				<Categories objectCategoriesData={objectCategoriesData} objectCategoriesError={objectCategoriesError} />
			</div>
		</div>
	)
}
